import './index.css'
import cn from 'clsx'

import React from 'react'
type Props = {
  header?: React.ReactNode
  children: React.ReactNode
  plane?: boolean
}

const PublicContent = ({
  header,
  children,
  plane,
}: Props): React.ReactElement<'div'> => (
  <div
    className={cn('public-section public-content', {
      'public-section--plane': plane,
    })}
  >
    {header && <div className="public-content-header">{header}</div>}
    {children}
  </div>
)

export default PublicContent
